import { Component } from '@angular/core';
import { Subject } from 'rxjs';

export interface IAbstractWidgetComponent {
  mode: WidgetMode;
  parametersChanged: Subject<ParameterChangedData>;
  isPersonalMode: boolean;
  defaultSizeX: number;
  defaultSizeY: number;
  initializeParameters(panelId: string, serializedParameters: string, onDeleteCallback: (panelId: string) => void): void;
}

export interface ParameterChangedData {
  panelId: string;
  serializedParamerters: string;
}

export enum WidgetMode {
  View,
  Edit,
  Preview
}

@Component({
  selector: 'app-abstract-widget',
  template: ''
})
export abstract class AbstractWidgetComponent implements IAbstractWidgetComponent {
  public mode: WidgetMode = WidgetMode.View;
  public parametersChanged: Subject<ParameterChangedData> = new Subject<ParameterChangedData>();
  public abstract defaultSizeX: number;
  public abstract defaultSizeY: number;

  public set isPersonalMode(value: boolean) {
    // override in child class for widgets with personal mode
  }
  public get isPersonalMode() {
    // override in child class for widgets with personal mode
    return false;
  }
  public abstract initializeParameters(panelId: string, serializedParameters: string, onDeleteCallback: (panelId: string) => void);
}
